import type { FaireProductEntity } from "../../entity_types/product";

export const p_h7exzf22xd: FaireProductEntity = {
  token: "p_h7exzf22xd",
  type: "product",
  name: "Vintage Gold Seashell Hair Claw Clip DP25D893",
  brandToken: "b_kw6x2ac3kg",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/bd0ffa6c9bd7946e4924b793b248ab108fabce4667b6bb12a52fdc3f327a5ed6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c59ca1c12d3b82e8d0f05db88b0360e78c4b058e61f9c8a7ca1db3a54d2b1a82.jpeg",
    "https://cdn.faire.com/fastly/19e9b6209736604e3b8e0cc5c80d9515a102bca62f849837e8dce344f12a99be.jpeg",
    "https://cdn.faire.com/fastly/ffcc87e7928769f02bff19d5a9bee56e4f2541182ee38f1d71e64cb7b8dd8e13.jpeg",
    "https://cdn.faire.com/fastly/d0d970c31c80c7a1d7cbcfef986c72140e909b9d15966ca6de654bc7df874509.jpeg",
    "https://cdn.faire.com/fastly/857dc29c636806d66ab3fc1a4e8cabd0a6127bf117d0a5437f40fb72fa88815b.jpeg",
  ],
  priceDollars: 3.87,
  description:
    "Feature:\n * Seashell\n * Vintage\n * Pleated\n * Simple, Sweet, Cute \n * Daily Fitting\n * Gift\n\n Weight: 84g\n\n Material: \n * Metal\n\n Package:\n * Package include 1 * hair claw.\n\n Note: Due to lighting, angle, camera and other reasons in the shooting process, may cause the product physical colour and picture differences, the colour in kind shall prevail!",
  tags: [],
  msrpDollars: 7.73,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:47.334Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
